import React from 'react';
import { Box, Typography } from '@mui/material';
import { BRANCH_RECEIPT_NUMBERING_ENABLED } from '../../../../config/feature-flags';
import {
  BRANCH_RECEIPT_NUMBER_LABEL,
  SALES_ORDER_NUMBER_LABEL,
} from '../../../../utils/sales/branch-receipt-numbering';

export interface SaleNumberDisplayProps {
  orderCode: string;
  branchReceiptCode?: string | null;
  /** Typography variant for both lines */
  variant?: 'body2' | 'caption';
  /** Show labels before values */
  showLabels?: boolean;
  /** Stack vertically (default) or inline with separator */
  layout?: 'stack' | 'inline';
}

const SaleNumberDisplay: React.FC<SaleNumberDisplayProps> = ({
  orderCode,
  branchReceiptCode,
  variant = 'body2',
  showLabels = false,
  layout = 'stack',
}) => {
  const showReceipt =
    BRANCH_RECEIPT_NUMBERING_ENABLED && branchReceiptCode != null && branchReceiptCode !== '';

  const saleLine = showLabels ? `${SALES_ORDER_NUMBER_LABEL}: ${orderCode}` : orderCode;
  const receiptLine = showLabels
    ? `${BRANCH_RECEIPT_NUMBER_LABEL}: ${branchReceiptCode}`
    : branchReceiptCode;

  if (!showReceipt) {
    return (
      <Typography variant={variant} component="span">
        {saleLine}
      </Typography>
    );
  }

  if (layout === 'inline') {
    return (
      <Typography variant={variant} component="span">
        {saleLine}
        <Box component="span" sx={{ mx: 0.5, opacity: 0.6 }}>
          ·
        </Box>
        {receiptLine}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      <Typography variant={variant}>{saleLine}</Typography>
      <Typography variant={variant} color="text.secondary">
        {receiptLine}
      </Typography>
    </Box>
  );
};

export default SaleNumberDisplay;
